import React, { useCallback } from "react";
import { ActiveStarIcon, DownloadIcon, fileIcons } from "../../Icons";
import { format } from "date-fns";
import {
  downloadFile,
  downloadFolder,
  // downloadFile,
  // downloadFolder,
  formatFileSize,
} from "../../utils/utils";
import ActionPopup from "../ActionPopup";
import { useAuth } from "../../../../features/auth/AuthContext";

const FileCard = ({
  details,
  onClick,
  handleMove,
  handleRename,
  handleDelete,
  isFav = false,
  selectedKeys = [],
  setSelectedKeys,
  changeFav,
  handleRestore,
  isBin = false,
}) => {
  const { token } = useAuth();

  const FileIcon = fileIcons?.[details?.file_type] || fileIcons?.["folder"];
  const name =
      details?.item_type === "folder"
        ? details?.folder_name
        : details?.file_name,
    uploadType = details?.upload_type
      ? details?.upload_type
      : details?.item_type === "folder"
      ? "Generated"
      : "",
    // isManual = details?.["upload_type"] === "Manual",
    isFolder = details?.item_type === "folder",
    fileSize = formatFileSize(details?.file_size),
    isSelected = selectedKeys.includes(details?.id),
    enableDelete = details?.upload_type
      ? details?.upload_type === "Manual"
      : details?.item_type === "file";

  const handleCardClick = useCallback(() => {
    if (typeof onClick === "function") {
      onClick(details);
    }
  }, [details, onClick]);

  const toggleRow = (key) => {
    const next = selectedKeys.includes(key)
      ? selectedKeys.filter((k) => k !== key)
      : [...selectedKeys, key];
    setSelectedKeys(next);
  };

  const handleFolderDownload = async (id, name = "folder") => {
    downloadFolder(token, id, name);
  };

  return (
    <div
      onClick={handleCardClick}
      className="flex items-start justify-between gap-2 p-1 mb-2"
      key={details?.id + name}
    >
      <div className="flex justify-between items-start gap-2">
        {setSelectedKeys && (
          <input
            type="checkbox"
            // onChange={() => toggleRow(key)}
            checked={isSelected}
            onClick={(e) => {
              e.stopPropagation();
              toggleRow(details?.id);
            }}
            style={{
              // accentColor: "#6366f1",
              width: 15,
              height: 15,
              cursor: "pointer",
            }}
          />
        )}
        {isFav && (
          <button
            type="button"
            className="flex items-center justify-center cursor-pointer bg-transparent border-none p-0 m-0"
            onClick={(e) => {
              e.stopPropagation();
              changeFav(details);
            }}
            aria-label={"Remove from favorites"}
          >
            <ActiveStarIcon />
          </button>
        )}
        <div className="flex items-start gap-2">
          {FileIcon && <FileIcon />}
          <div className="flex flex-col items-start gap-2">
            <div
              title={name}
              className="truncate w-[8rem] text-[#555555] font-normal text-[0.92rem]"
            >
              {name}
            </div>
            <div className="text-[0.85rem]">
              {details?.updated_at
                ? format(new Date(details?.updated_at), "dd/MM/yy")
                : ""}
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-start gap-2">
        <div className="flex flex-col items-end gap-2">
          <div className="file-type">{uploadType}</div>
          <span className="truncate text-[#555555] font-normal text-[0.8rem]">
            {fileSize}
          </span>
        </div>
        <ActionPopup
          file={details}
          move={enableDelete ? handleMove : null}
          rename={enableDelete ? handleRename : null}
          handleDelete={enableDelete ? handleDelete : null}
          isFolder={isFolder}
          favourite={changeFav}
          handleRestore={handleRestore}
          download={
            isBin ? null : isFolder ? handleFolderDownload : downloadFile
          }
        />
      </div>
    </div>
  );
};

export default FileCard;
